export { default } from 'cccisd-game-zoou-er0';
